"use client";

import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { BuyerDealPanel } from "@/components/deal/BuyerDealPanel";

import { BuyerDealHistory } from "@/components/deal/buyer-deal-history";
import { ListingBuyAgainButton } from "./listing-buy-again";

interface ListingRailProps {
  productId: Id<"products">;
  children: React.ReactNode;
}

export function ListingRail({ productId, children }: ListingRailProps) {
  const { isAuthenticated } = useConvexAuth();
  const data = useQuery(
    api.listings.queries.getDealsOnListing,
    isAuthenticated ? { productId } : "skip",
  );

  if (
    data?.viewerRole === "buyer" &&
    data.activeDeal &&
    !data.activeDeal.isTerminal
  ) {
    return (
      <BuyerDealPanel
        deal={data.activeDeal}
        buyAgain={
          data.buyAgainOrderId ? (
            <ListingBuyAgainButton
              orderId={data.buyAgainOrderId}
              productId={productId}
            />
          ) : null
        }
        history={
          <BuyerDealHistory key={productId} productId={productId} page={data} />
        }
      />
    );
  }

  return <>{children}</>;
}
